import { Component, Input } from '@angular/core';
import { MenuController, NavController } from 'ionic-angular';
import { BuscadorPage } from '../../pages/buscador/buscador';
import { FiltroPage } from '../../pages/filtro/filtro';

/**
 * Generated class for the CabeceraTituloComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'cabecera-titulo',
  templateUrl: 'cabecera-titulo.html'
})
export class CabeceraTituloComponent {

  @Input() titulo: string;

  constructor(public menuCtrl:MenuController, public navCtrl: NavController) {

  }

  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

  goToFiltro(){
    this.navCtrl.push(FiltroPage);
  }
}



// WEBPACK FOOTER //
// ./src/components/cabecera-titulo/cabecera-titulo.ts